import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';
import { FieldAgentClient } from 'ep-bt-field-agent-proxy';
import { EpGridComponent, IEpGridModel, IEpGridSelectionOptions } from '@epicor/kinetic';
declare var $: any;

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'epbt-fa-customer-info',
  templateUrl: './epbt-fa-customer-info.component.html',
  styleUrls: ['./epbt-fa-customer-info.component.scss']
})
export class EpbtFaCustomerInfoComponent implements OnInit {

  @Input()
  customerId: any;

  cardModel: IEpGridModel[];
  // Commented as we are sending both address and contact info in the card model
  // mapCardModel: IEpGridModel;
  salescardModel: IEpGridModel[] = [];

  @ViewChild(EpGridComponent, {static: false}) grid: EpGridComponent;
  showGrid = true;
  public gridModel: IEpGridModel;
  public pageSize = 15;
  data: any;
  @ViewChild('emailTemplate', {static: true}) emailTemplate: TemplateRef<any>;
  @ViewChild('mobileTemplate', {static: true}) mobileTemplate: TemplateRef<any>;
  @ViewChild('telTemplate', {static: true}) telTemplate: TemplateRef<any>;
  @ViewChild('telTemplate', {static: true}) tel2Template: TemplateRef<any>;

  constructor(private client: FieldAgentClient) { }

  ngOnInit() {
    // 1674
    this.client.getCustomerAccountDetails(this.customerId).subscribe(res => {
      if (res != null) {
        this.prepareData(res);
      }
    });
    this.gridModel = this.getGridModel();
  }

  // Prepare the data as required for card
  prepareData(modelData: any) {
    this.cardModel = [
      {
        userData: {
          headertitle: 'Address',
          address1: modelData.invoiceContactInformation.address.address1,
          address2: modelData.invoiceContactInformation.address.address2,
          address3: modelData.invoiceContactInformation.address.address3,
          city: modelData.invoiceContactInformation.address.city,
          county: modelData.invoiceContactInformation.address.county,
          postCode: modelData.invoiceContactInformation.address.postCode,
          country: modelData.invoiceContactInformation.address.country,
          address: this.getAddressData(modelData.invoiceContactInformation.address),
          cityInfo: this.getCityData(modelData.invoiceContactInformation.address),
          countryInfo: this.getCountryData(modelData.invoiceContactInformation.address),
          fullAddress: this.getFullAddressData(modelData.invoiceContactInformation.address)
        }
      },
      {
        userData: {
          headertitle: 'Contact Details',
          name: modelData.invoiceContactInformation.contactName,
          telephone1: modelData.invoiceContactInformation.telephone1,
          telephone2: modelData.invoiceContactInformation.telephone2,
          phone: modelData.invoiceContactInformation.contactNumber,
          email: modelData.emailAddress
        }
      }
    ];

    // sales data
    modelData.salesReps.forEach(element => {
      const cardModel: IEpGridModel = {
        userData: {
          headertitle: element.name,
          telephone1: element.telephone,
          telephone2: null,
          phone: element.mobile,
          email: element.email
        }
      };
      this.salescardModel.push(cardModel);
    });
    this.gridModel.data = this.salescardModel;


    // Commented as we are sending both address and contact info in the card model
    // this.mapCardModel = {
    //   userData: {
    //     headertitle: 'Address',
    //     address1: modelData.invoiceContactInformation.address.address1,
    //     address2: modelData.invoiceContactInformation.address.address2,
    //     address3: modelData.invoiceContactInformation.address.address3,
    //     city: modelData.invoiceContactInformation.address.city,
    //     county: modelData.invoiceContactInformation.address.county,
    //     postCode: modelData.invoiceContactInformation.address.postCode,
    //     country: modelData.invoiceContactInformation.address.country,
    //     fullAddress: this.getAddressData(modelData.invoiceContactInformation.address)
    //   }
    // }
  }

  // This method will combines the full address of map
  getFullAddressData(addressObj: any) {
    const address = [addressObj.address1, addressObj.address2,
    addressObj.address3, addressObj.city,
    addressObj.county, addressObj.postCode, addressObj.country].filter(Boolean).join(', ');
    return address;
  }

  getAddressData(addressObj: any) {
    const address = [addressObj.address1, addressObj.address2,
    addressObj.address3].filter(Boolean).join(', ');
    return address;
  }

  getCityData(addressObj: any) {
    const address = [addressObj.city,
    addressObj.county, addressObj.postCode].filter(Boolean).join(', ');
    return address;
  }

  getCountryData(addressObj: any) {
    const address = [addressObj.country].filter(Boolean).join(', ');
    return address;
  }


  getGridModel(): IEpGridModel {
    const selectionOptions: IEpGridSelectionOptions = {
      selectByField: 'customerId',
      selectedKeys: [],
    };
    const model: IEpGridModel = {
      resizable: false,
      reorderable: false,
      groupable: false,
      filterable: false,
      pageable: true,
      pageSize: this.pageSize,
      scrollable: 'scrollable',
      rowHeight: 20,
      sortable: true,
      height: this.getHeight(),
      selectionOptions: selectionOptions,
      data: this.data,
      columns: [
        { field: 'userData.headertitle', title: 'NAME', width: 120, hidden: false },
        { field: 'userData.telephone1', title: 'TELEPHONE', width: 80, hidden: false, cellTemplate: this.telTemplate },
        { field: 'userData.telephone2', title: 'TELEPHONE 2', width: 30, hidden: true, cellTemplate: this.tel2Template },
        { field: 'userData.phone', title: 'MOBILE', width: 80, hidden: false, cellTemplate: this.mobileTemplate },
        { field: 'userData.email', title: 'EMAIL', width: 100, hidden: false, cellTemplate: this.emailTemplate }
      ]
    };
    return model;
  }

  getHeight(): number {
    const height = parseInt($('body').height());

    if (height > 900) {
      // return 300;
      return 700;
    } else {
      return 280; // return 500;
    }
  }

}
